import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import type { BuildKind } from '@sim/content/subject-kind';
import type { SubscriberColumn } from '@sim/core/subscriber';
import type { GridPos } from '@sim/core/types';

export interface FunctionPickerTarget {
  column: SubscriberColumn;
  pos: GridPos;
  /** Set when an already-installed function was clicked: picking then swaps that row rather than appending. */
  row?: number;
}

/** A toolbar button being dragged from the toolbar, tracked at the pointer. */
export interface ToolbarDrag {
  kind: BuildKind;
  x: number;
  y: number;
}

@Injectable({ providedIn: 'root' })
export class UiStateService {
  readonly tutorialLogOpen = signal(false);
  readonly recipesModalOpen = signal(false);
  readonly hoveredPos = signal<GridPos | null>(null);
  readonly rxSidebarOpen = signal(true);
  /** A confirmed reset request — the game canvas plays a dissolve transition before actually resetting. */
  readonly resetRequested = new Subject<void>();
  /** Non-null while the function inventory picker is open for a specific empty "+" slot. */
  readonly functionPicker = signal<FunctionPickerTarget | null>(null);
  /** Non-null while a creation-tool button is being dragged from the toolbar toward the canvas. */
  readonly toolbarDrag = signal<ToolbarDrag | null>(null);
}
